import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-3 tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] md:tw-p-10" }
const _hoisted_2 = { class: "tw-bg-[#387DFF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded tw-mr-[10px]" }
const _hoisted_3 = { class: "tw-text-white tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_4 = { class: "tw-bg-[#F2F8FF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded" }
const _hoisted_5 = { class: "tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_6 = { class: "tw-mt-[12px]" }
const _hoisted_7 = { class: "tw-mr-[15px] tw-font-semibold tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_8 = { class: "tw-font-normal tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_9 = { class: "tw-p-[20px] md:tw-p-[40px] !tw-pb-[0px] tw-text-sm tw-font-medium tw-text-[#211F58]" }
const _hoisted_10 = { class: "tw-text-lg tw-font-semibold tw-mb-[20px]" }
const _hoisted_11 = {
  sm: "7",
  class: "tw-font-normal"
}
const _hoisted_12 = { class: "tw-p-10 modal-assessment" }
const _hoisted_13 = { class: "button-container tw-flex tw-justify-end" }

import { getComponentUiText } from "@/utils/utilities";
import { ComputedRef, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { IAssessmentQuestion } from "@/interfaces/assessments/IAssessmentQuestion";
import { PropType } from "vue";
import store from "@/store";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  checklistStatusId,
} from "@/utils/constants";
import { computed } from "vue";
import ButtonLoading from "@/components/common/buttonLoading.vue";
import WysiwygEditor from "../common/wysiwygEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalAddNoteAssessment',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  title: {
    type: String,
    default: "",
  },
  titleInut: {
    type: String,
    default: "",
  },
  inutPlaceholder: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    required: false,
    default: ASSESSMENT_ANSWER_STORE_TYPE.NOTES,
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;



const isLoading = ref(false);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => {
  const statusId =
    store.getters["Assessment/getChecklistInforDetail"].checklistStatusId;

  return (
    statusId === checklistStatusId.completed ||
    statusId === checklistStatusId.paused ||
    statusId === checklistStatusId.defunct
  );
});

let showRef = ref(props.show);
let notInfoVisible = ref(true);
let noteData = ref(props.value.note);
const isCallApi = ref(false);
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

const handleCloseModal = (isOutside = false) => {
  if (isOutside) {
    if (isLoading.value) {
      return;
    }
    addNote();
    return;
  }
  showRef.value = false;
  emit("update:show", showRef.value);
};

const closeModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const addNote = async () => {
  if (
    noteData.value === props.value.note ||
    (noteData.value === "" &&
      (props.value.note === undefined || props.value.note === null))
  ) {
    handleCloseModal();
    return;
  }
  isLoading.value = true;

  await store.dispatch("Assessment/updateAnswer", {
    checklistId: props.value.checklistId,
    checklistItemId: props.value.checklistItemId,
    answer: noteData.value,
    type: props.type,
  });

  handleCloseModal();
  isLoading.value = false;
};

const currentValueSearch = (value: any) => {
  noteData.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]",
    visible: _unref(showRef),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (handleCloseModal(true)))
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: "modal-header",
        title: __props.title,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.value.category), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(props.value.subCategory), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.value.questionNumber), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(props.value.questionTitle), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.titleInut), 1),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(WysiwygEditor, {
            modelValue: _unref(noteData),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(noteData) ? (noteData).value = $event : noteData = $event)),
            "include-image": false,
            "is-disabled": isChecklistCompleted.value,
            height: '200px',
            placeholder: 
            isChecklistCompleted.value
              ? ''
              : _unref(getComponentUiText)(
                  'app-component-assessments-override-question-note-prompt-1',
                )
          ,
            "onUpdate:value": currentValueSearch
          }, null, 8, ["modelValue", "is-disabled", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: _normalizeClass(`hover:tw-bg-[#096cdb] hover:tw-text-[#fff] tw-justify-center tw-h-[39px] tw-cursor-pointer tw-flex tw-flex-col tw-items-center tw-self-end tw-gap-2.5 tw-px-[18px] tw-rounded-[26.909px]  tw-bg-[#fff] tw-border-[#387DFF] tw-text-[#387DFF] tw-border-solid tw-border-[1px] tw-mr-[15px] tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%]`),
            onClick: closeModal
          }, [
            _createElementVNode("div", null, _toDisplayString(_unref(getComponentUiText)("app-common-action-cancel-button-1")), 1)
          ]),
          _createVNode(ButtonLoading, {
            title: 
            _unref(getComponentUiText)(
              'app-component-assessment-modal-assessment-save-button-1',
            )
          ,
            disabled: isChecklistCompleted.value,
            "is-loading": isLoading.value,
            onClickAction: addNote
          }, null, 8, ["title", "disabled", "is-loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})